// extracted by mini-css-extract-plugin
module.exports = {"story-card":"_1RdaI","podcast-embed":"_3msrG","sub-appeal-div":"_23LZ2","span-full":"_15ZoU"};